module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.element.type == 'Section') ? _c('div', {
    staticClass: "section-bar",
    class: {
      selected: _vm.element.key == _vm.selectedSectionKey
    }
  }, [_vm._v("\n        " + _vm._s(_vm.element.title) + "\n        "), (_vm.element.status) ? _c('span', {
    staticStyle: {
      "font-size": "0.7em"
    }
  }, [_vm._v("(" + _vm._s(_vm.element.status) + ")")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "30px",
      "float": "right",
      "margin-top": "-2px"
    }
  }, [_c('v-icon', {
    staticClass: "section-star",
    class: {
      complete: _vm.element.complete
    },
    on: {
      "click": _vm.toggleSectionComplete
    }
  }, [_vm._v("star_rate")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Divider') ? _c('hr', {
    staticStyle: {
      "border": "solid 0.5px #cccccc"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Text') ? [(_vm.element.multiLine) ? _c('v-textarea', {
    class: {
      'element-compact': _vm.element.compact
    },
    attrs: {
      "label": _vm.element.title,
      "hide-details": !_vm.element.showHint,
      "single-line": _vm.element.compact
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }) : _c('v-text-field', {
    class: {
      'element-compact': _vm.element.compact
    },
    attrs: {
      "label": _vm.element.title,
      "hide-details": !_vm.element.showHint,
      "single-line": _vm.element.compact
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Percent') ? _c('v-text-field', {
    class: {
      'element-compact': _vm.element.compact
    },
    attrs: {
      "suffix": "%",
      "label": _vm.element.title,
      "hide-details": !_vm.element.showHint,
      "single-line": _vm.element.compact
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Rating') ? [_c('div', {
    staticStyle: {
      "margin-top": "2px",
      "font-size": "12px",
      "color": "#888"
    }
  }, [_vm._v(_vm._s(_vm.element.title))]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.saveValue(_vm.element)
      }
    }
  }, [_c('v-rating', {
    class: {
      'element-compact': _vm.element.compact
    },
    staticStyle: {
      "margin-left": "-9px",
      "margin-top": "-7px"
    },
    attrs: {
      "color": "yellow darken-2",
      "background-color": "grey lighten-2",
      "xfull-icon": "favorite",
      "xempty-icon": "favorite_border",
      "label": _vm.element.title,
      "hide-details": !_vm.element.showHint,
      "single-line": _vm.element.compact
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Slider') ? _c('div', [(!_vm.element.compact) ? _c('div', {
    staticClass: "grey--text text--darken-2 truncate",
    staticStyle: {
      "font-size": "12px",
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s((_vm.element.labelTop ? _vm.element.title : ' ')))]) : _vm._e(), _vm._v(" "), _c('v-slider', {
    attrs: {
      "label": (_vm.element.labelTop ? '' : _vm.element.title),
      "hide-details": !_vm.element.showHint,
      "single-line": _vm.element.compact
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.element.type == 'List') ? [(_vm.element.allowCustomText) ? _c('v-combobox', {
    class: {
      'element-compact': _vm.element.compact
    },
    attrs: {
      "id": _vm.element.key,
      "clearable": "",
      "items": _vm.splitOptions(_vm.element),
      "label": _vm.element.title,
      "hide-details": !_vm.element.showHint,
      "single-line": _vm.element.compact
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }) : _c('v-autocomplete', {
    class: {
      'element-compact': _vm.element.compact
    },
    attrs: {
      "id": _vm.element.key,
      "clearable": "",
      "items": _vm.splitOptions(_vm.element),
      "label": _vm.element.title,
      "hide-details": !_vm.element.showHint,
      "single-line": _vm.element.compact
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Options') ? [(!_vm.element.compact) ? _c('div', {
    staticClass: "grey--text text--darken-2 truncate",
    staticStyle: {
      "font-size": "12px",
      "margin-top": "0px",
      "margin-bottom": "-15px"
    }
  }, [_vm._v(_vm._s(_vm.element.title))]) : _vm._e(), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "mandatory": false,
      "hide-details": !_vm.element.showHint
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }, _vm._l((_vm.splitOptions(_vm.element)), function(option) {
    return _c('v-radio', {
      key: option,
      attrs: {
        "label": option,
        "value": option,
        "color": "primary"
      }
    })
  }), 1)] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Checkbox List') ? [(!_vm.element.compact) ? _c('div', {
    staticClass: "grey--text text--darken-2 truncate",
    staticStyle: {
      "font-size": "12px",
      "margin-top": "0px",
      "margin-bottom": "0px"
    }
  }, [_vm._v(_vm._s(_vm.element.title))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.splitOptions(_vm.element)), function(option) {
    return _c('v-checkbox', {
      key: option,
      staticClass: "checkbox-list",
      attrs: {
        "label": option,
        "value": option,
        "color": "primary"
      },
      on: {
        "change": function($event) {
          return _vm.saveValue(_vm.element)
        }
      },
      model: {
        value: (_vm.checkboxListValue),
        callback: function($$v) {
          _vm.checkboxListValue = $$v
        },
        expression: "checkboxListValue"
      }
    })
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Heading') ? _c('div', {
    staticClass: "element-heading"
  }, [_vm._v("\n        " + _vm._s(_vm.element.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Switch') ? [_c('v-switch', {
    attrs: {
      "label": (_vm.element.labelTop ? '' : _vm.element.title),
      "hide-details": !_vm.element.showHint,
      "color": "primary"
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Checkbox') ? [_c('v-checkbox', {
    attrs: {
      "label": _vm.element.title,
      "color": "primary",
      "hide-details": !_vm.element.showHint
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'DateTime') ? [_c('DateTime', {
    attrs: {
      "label": _vm.element.title
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Date') ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('DateBox', {
    ref: 'datebox' + _vm.element.key,
    staticClass: "field-width",
    attrs: {
      "label": _vm.element.title,
      "hide-details": _vm.hideHint(_vm.element),
      "single-line": _vm.element.compact,
      "disabled": _vm.element.locked,
      "short": _vm.element.short,
      "baseDate": _vm.getValueFromName(_vm.element.relativeTo)
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('v-menu', {
    attrs: {
      "left": "",
      "close-on-content-click": false,
      "nudge-width": 200,
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "small": "",
            "color": "grey lighten-4"
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "grey"
          }
        }, [_vm._v("arrow_drop_down_circle")])], 1)]
      }
    }], null, false, 2389600186),
    model: {
      value: (_vm.dateMenuVisible),
      callback: function($$v) {
        _vm.dateMenuVisible = $$v
      },
      expression: "dateMenuVisible"
    }
  }, [_vm._v(" "), _c('v-card', [_c('div', {
    staticClass: "mini-menu-bar"
  }, [_vm._v(_vm._s(_vm.element.title))]), _vm._v(" "), _c('v-date-picker', {
    staticClass: "elevation-0",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": _vm.datePickerChanged,
      "dblclick": function($event) {
        _vm.dateMenuVisible = false
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.element.value,
      "text": ""
    },
    on: {
      "click": _vm.makeTaskFromDate
    }
  }, [_vm._v("Make Task")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dateMenuVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Currency') ? _c('CurrencyBox', {
    staticClass: "field-width",
    attrs: {
      "label": _vm.element.title,
      "hide-details": _vm.hideHint(_vm.element),
      "single-line": _vm.element.compact,
      "disabled": _vm.element.locked
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Status') ? _c('StatusBox', {
    attrs: {
      "options": _vm.element.options
    },
    on: {
      "input": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Button') ? [_c('v-btn', {
    staticStyle: {
      "margin-top": "13px",
      "margin-left": "-8px",
      "margin-right": "-6px"
    },
    attrs: {
      "color": (_vm.element.primary ? 'primary' : 'grey lighten-2'),
      "icon": Boolean(_vm.element.buttonIcon)
    },
    on: {
      "click": function($event) {
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('button', _vm.element)
      }
    }
  }, [(_vm.element.buttonIcon) ? _c('v-icon', [_vm._v(_vm._s(_vm.element.buttonIcon))]) : _vm._e(), _vm._v(" "), (!_vm.element.buttonIcon) ? [_vm._v(_vm._s(_vm.element.title))] : _vm._e()], 2)] : _vm._e(), _vm._v(" "), (_vm.element.type == 'User Chooser') ? [_c('UserChooser', {
    staticStyle: {
      "margin-top": "18px"
    },
    attrs: {
      "role": _vm.element.role,
      "label": _vm.element.title
    },
    model: {
      value: (_vm.userChooserUser),
      callback: function($$v) {
        _vm.userChooserUser = $$v
      },
      expression: "userChooserUser"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Email') ? [_c('ElementButton', {
    attrs: {
      "element": _vm.element,
      "icon": "email"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('action', 'email', _vm.element)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'SMS') ? [(_vm.element.complete) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('ElementButton', _vm._g({
          attrs: {
            "element": _vm.element,
            "icon": "chat"
          }
        }, on))]
      }
    }], null, false, 1938783601)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$emit('action', 'sms', _vm.element)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Send Another")])], 1)], 1)], 1) : _c('ElementButton', {
    attrs: {
      "element": _vm.element,
      "icon": "sms"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('action', 'sms', _vm.element)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Contact Selector') ? [_vm._l((_vm.contactElementsForRole(_vm.element.role)), function(contactElement) {
    return _c('div', {
      key: contactElement.key
    }, [_c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('div', _vm._g({}, on), [_c('ElementButton', {
            attrs: {
              "complete": true,
              "text": _vm.fullName(contactElement.contact) + ' (' + contactElement.role + ')',
              "element": _vm.element,
              "icon": "account_circle"
            }
          })], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.$emit('action', 'contact-view', contactElement)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("View")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.$emit('action', 'contact', _vm.element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add another " + _vm._s(contactElement.role))])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.$emit('action', 'contact-remove', contactElement)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Remove " + _vm._s(contactElement.role))])], 1)], 1)], 1)], 1)
  }), _vm._v(" "), (!_vm.contactElementsForRole(_vm.element.role).length) ? _c('ElementButton', {
    attrs: {
      "element": _vm.element,
      "text": _vm.element.title,
      "icon": "account_circle"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('action', 'contact', _vm.element)
      }
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.element.type == 'File') ? [_c('div', {
    staticClass: "element-button"
  }, [_vm._v("File: " + _vm._s(_vm.element.name))])] : _vm._e(), _vm._v(" "), (_vm.element.type == 'File Upload') ? [(!_vm.element.compact) ? _c('div', {
    staticStyle: {
      "height": "10px"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-left": "0px"
    }
  }, [_c('UploadElement', {
    staticStyle: {
      "align-self": "top"
    },
    attrs: {
      "element": _vm.element
    },
    on: {
      "menu": _vm.uploadElementMenu
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "16px",
      "padding": "3px",
      "align-self": "center"
    }
  }, [_vm._v(_vm._s(_vm.element.title))])], 1)] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Widget' && _vm.element.widget == 'Outstandings Diagram') ? [_c('OutstandingsDiagram', {
    on: {
      "click": function($event) {
        void _vm.x
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Scheduler') ? [_c('ElementButton', {
    attrs: {
      "xxxv-on": "on",
      "element": _vm.element,
      "text": (_vm.element.complete ? 'Scheduled: ' : 'Schedule ') + _vm.element.title,
      "icon": "today"
    },
    on: {
      "click": function($event) {
        return _vm.showTaskDialog(_vm.element)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Exporter') ? [_c('ElementButton', {
    attrs: {
      "xxxv-on": "on",
      "element": _vm.element,
      "text": "Export to CRM",
      "icon": "mdi-database-export"
    },
    on: {
      "click": function($event) {
        return _vm.exportHistory(_vm.element)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Charge') ? [_c('ElementButton', {
    attrs: {
      "xxxv-on": "on",
      "element": _vm.element,
      "text": (_vm.element.value ? _vm.element.value : _vm.element.title),
      "icon": "monetization_on"
    },
    on: {
      "click": function($event) {
        return _vm.showChargeDialog(_vm.element)
      }
    }
  }), _vm._v(" "), (_vm.chargeDialogData.settings.visible) ? _c('ChargeDialog', {
    attrs: {
      "settings": _vm.chargeDialogData.settings,
      "charge": _vm.chargeDialogData.charge
    },
    on: {
      "saved": _vm.chargeSaved
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Lookup') ? [(!_vm.element.help) ? _c('v-text-field', {
    attrs: {
      "label": _vm.element.title,
      "hint": _vm.merge(_vm.element.lookup)
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }) : _c('div', {
    staticStyle: {
      "font-size": "16px"
    },
    style: ({
      'padding-top': (_vm.element.compact ? '2px' : '21px')
    })
  }, [_c('a', {
    class: {
      'grey--text': !_vm.element.value
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('action', 'display-lookup', _vm.element)
      }
    }
  }, [_vm._v(_vm._s(_vm.element.title))])])] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Html') ? [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.merge(_vm.element.value))
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'LoanAttributes') ? [_c('div', {
    staticClass: "element-label"
  }, [_vm._v("\n            " + _vm._s(_vm.element.title) + "\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.loanAttributes()) + "\n        ")])] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Jump') ? [_c('ElementButton', {
    attrs: {
      "complete": _vm.isTargetComplete(_vm.element),
      "element": _vm.element,
      "icon": "gps_fixed"
    },
    on: {
      "click": function($event) {
        return _vm.jumpFromElement(_vm.element)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Outstanding') ? [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "text-selectable",
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.element.text) + "\n\n                "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticStyle: {
            "display": "inline-block",
            "cursor": "pointer"
          }
        }, on), [_c('flag', {
          attrs: {
            "error": _vm.element.status && _vm.element.status.indexOf('Waiting') > -1,
            "success": _vm.element.status && _vm.element.status.indexOf('Sent') > -1,
            "purple": _vm.element.status == 'Settlement Condition',
            "orange": _vm.element.status == 'Waiting for Broker',
            "darkred": _vm.element.status == 'Waiting for Processor'
          }
        }, [_vm._v(_vm._s(_vm.element.status))])], 1)]
      }
    }], null, false, 3179923581)
  }, [_vm._v(" "), _c('v-list', [_vm._l((_vm.statusOptions), function(option, index) {
    return _c('v-list-item', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.updateElementProperty(_vm.element, 'status', option)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(option))])], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.bulkChangeOutstandings('Waiting', 'Ready to Send')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("All Ready")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.bulkChangeOutstandings('Ready to Send', 'Sent')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("All Sent")])], 1)], 2)], 1), _vm._v(" "), _vm._l((_vm.element.linkedFileKeys), function(linkedFileKey) {
    return [_c('a', {
      key: linkedFileKey,
      staticClass: "transparent",
      attrs: {
        "href": _vm.fileFromId(linkedFileKey).value,
        "target": "_blank"
      }
    }, [_c('flag', {
      staticClass: "clickable",
      attrs: {
        "white": ""
      }
    }, [_vm._v(_vm._s(_vm.fileFromId(linkedFileKey).fileName))])], 1)]
  }), _vm._v(" "), _c('div', {
    staticClass: "grey--text"
  }, [_vm._v("\n                " + _vm._s(_vm.element.response) + "\n                ")])], 2), _vm._v(" "), _c('div', [_c('UploadElement', {
    staticStyle: {
      "align-self": "top"
    },
    attrs: {
      "element": _vm.element
    }
  })], 1)])] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Checklist') ? [_c('div', {
    staticStyle: {
      "display": "flex",
      "padding-left": "4px"
    },
    on: {
      "click": function($event) {
        return _vm.toggleChecklist(_vm.element)
      }
    }
  }, [_c('div', [_c('v-progress-circular', {
    attrs: {
      "value": _vm.element.percent || 0,
      "color": "blue",
      "width": 6,
      "size": 30,
      "rotate": -90
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1",
      "font-size": "16px",
      "color": "#555",
      "padding-left": "10px",
      "padding-top": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.element.title))]), _vm._v(" "), (_vm.element.collapsed) ? _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "0px"
    }
  }, [_vm._v("keyboard_arrow_down")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-expand-transition', [(!_vm.element.collapsed) ? _c('checklist', {
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "list": _vm.element.checklist,
      "passBack": {
        element: _vm.element
      }
    },
    on: {
      "save": _vm.saveChecklist
    }
  }) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Widget') ? [(_vm.element.widget == 'Import Outstandings') ? _c('ImportItems', {
    attrs: {
      "compact": _vm.element.compact
    },
    on: {
      "importItems": _vm.importItems,
      "saveState": _vm.saveState
    }
  }) : _vm._e(), _vm._v(" "), (_vm.element.widget == 'Element Summary') ? _c('ElementSummary') : _vm._e(), _vm._v(" "), (_vm.element.widget == 'Loan Diagram') ? [(_vm.element.version == '2') ? _c('HomeLoan', {
    ref: "hld",
    attrs: {
      "homeLoan": _vm.element.diagram2,
      "passBack": {
        element: _vm.element
      }
    },
    on: {
      "save": _vm.saveLoanDiagram2,
      "change": _vm.loanDiagramChanged
    }
  }) : _c('LoanDiagram', {
    attrs: {
      "diagram": _vm.element.diagram,
      "passBack": {
        element: _vm.element
      }
    },
    on: {
      "save": _vm.saveLoanDiagram
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.widget == 'Transaction Summary') ? _c('TransactionSummary', {
    on: {
      "jump": _vm.jumpToElement,
      "save": _vm.saveElement
    }
  }) : _vm._e(), _vm._v(" "), (_vm.element.widget == 'Coming Up') ? _c('ComingUp', {
    attrs: {
      "element": _vm.element
    },
    on: {
      "jump": _vm.jumpToElement,
      "save": _vm.saveElement
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('TaskDialog', {
    attrs: {
      "task": _vm.taskDialog.model,
      "settings": _vm.taskDialog.settings
    },
    on: {
      "save": _vm.saveTask
    }
  }), _vm._v(" "), (_vm.element.type == 'Exporter' && _vm.exporterDialog.settings.visible) ? _c('ExporterDialog', {
    attrs: {
      "elements": _vm.elements,
      "settings": _vm.exporterDialog.settings
    },
    on: {
      "save": _vm.exportSave
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f13e460"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ElementItem.vue
// module id = 2573
// module chunks = 1